(function () {
  document.addEventListener('DOMContentLoaded', function () {
    const wallArtViewers = document.querySelectorAll('.wall-art-viewer--clickable[data-wall-art-target]');

    function isVisible(el) {
      if (!el) return false;
      const cs = getComputedStyle(el);
      return cs.display !== 'none';
    }

    wallArtViewers.forEach(function (viewer) {
      viewer.addEventListener('click', function (e) {
        e.preventDefault();

        // Close modal if it exists
        const modal = document.getElementById('formModal');
        if (modal) {
          modal.style.display = 'none';
        }

        // Find all AR anchors
        const anchors = document.querySelectorAll(
          'a.cm-activate-ios-quick-look, a.cm-activate-android-scene-viewer, button.cm-launch-ar-btn'
        );

        // Find the first visible anchor
        const targetElement = Array.from(anchors).find(isVisible);

        if (targetElement) {
          console.log('Clicking element:', targetElement);
          setTimeout(() => {
            targetElement.click();
          }, 100);
        } else {
          console.warn('No visible AR element found');
        }
      });

    });
  });
})();
